import { Box, Stack } from '@locus-taxy/encore-mui';
import { CustomDetailsRemoteContainer } from '../components/EntityDetails/CustomDetailsRemoteContainer';
import type { FormSchema } from '../components/EntityDetails/types';
import type { CustomDetailsConfig } from './customDetailsConfig';

interface CustomDetailsPageContainerProps {
  config: CustomDetailsConfig;
  clientId?: string;
  entityName?: string;
  entityTitle?: string;
  rootInstanceKey?: string;
  entityData?: Record<string, unknown>;
  detailsForm?: FormSchema;
  showTimeline?: boolean;
  remountKey?: number;
  entitySchemaInfo?: unknown;
}

export function CustomDetailsPageContainer({
  config,
  clientId = '',
  entityName = '',
  entityTitle = '',
  rootInstanceKey,
  entityData = {},
  detailsForm,
  showTimeline = false,
  remountKey = 0,
  entitySchemaInfo,
}: Readonly<CustomDetailsPageContainerProps>) {
  return (
    <Stack sx={{ height: '100%', overflow: 'hidden' }}>
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <CustomDetailsRemoteContainer
          config={config}
          clientId={clientId}
          entityName={entityName}
          entityTitle={entityTitle}
          rootInstanceKey={rootInstanceKey}
          entityData={entityData}
          detailsForm={detailsForm}
          showTimeline={showTimeline}
          remountKey={remountKey}
          entitySchemaInfo={entitySchemaInfo}
        />
      </Box>
    </Stack>
  );
}
